import {Injectable} from '@angular/core';

@Injectable()
export class UtilsService {
  constructor() {}

  pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }

  getSeconds(ticks: number) {
    let self = this;
    return self.pad(ticks % 60);
  }

  getMinutes(ticks: number) {
    let self = this;
    return self.pad(Math.floor(ticks / 60) % 60);
  }

  private filterResults(windowParam: number, documentElementParam: number, bodyParam: number) {
    var result = windowParam ? windowParam : 0;
    if (documentElementParam && (!result || result > documentElementParam)) result = documentElementParam;
    return bodyParam && (!result || result > bodyParam) ? bodyParam : result;
  }

  getScrollTopPosition(): number {
    return this.filterResults(
      window.pageYOffset ? window.pageYOffset : 0,
      document.documentElement ? document.documentElement.scrollTop : 0,
      document.body ? document.body.scrollTop : 0
    );
  }

  getClientWidth(): number {
    return this.filterResults(
      window.innerWidth ? window.innerWidth : 0,
      document.documentElement ? document.documentElement.clientWidth : 0,
      document.body ? document.body.clientWidth : 0
    );
  }

  getClientHeight(): number {
    return this.filterResults(
      window.innerHeight ? window.innerHeight : 0,
      document.documentElement ? document.documentElement.clientHeight : 0,
      document.body ? document.body.clientHeight : 0
    );
  }
}
